import React, {Component} from "react";
import APP_VERSIONS from '../../../version.json';
import userStore from "../../store/userStore";
import {autorun} from "mobx";

//TODO: add CI commit version to versions
export default class AppVersion extends Component{

    state = {
        version: APP_VERSIONS.version,
        apiVersion: null,
    }


    async componentDidMount() {
        await userStore.fetchApiVersion();
        this.dispose = autorun(() => {
            const version = userStore.apiVersion.version;
            if(version != null){
                this.setState({apiVersion: version});
            }
        })
    }

    componentWillUnmount() {
        if (this.dispose) this.dispose();
    }

    render() {
        return(
            <div className="sidebar-ver">
                <span>fv:{this.state.version}</span>
                <span>av:{this.state.apiVersion}</span>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/Sidebar/AppVersion.jsx